import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

@Component({
	selector: 'app-comment-dialog',
	templateUrl: './comment-dialog.component.html',
	styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent implements OnInit {
	public itemId: string;
	public orderId: string;

	constructor(
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: {
			itemId: string,
			orderId: string, 
		}
	) {
	}

	ngOnInit(): void {
		this.itemId = this.data.itemId;
		this.orderId = this.data.orderId;
	}

	doCloseDialog() {
		this.dialog.closeAll();
	}
}
